'use client'

import { useEffect, useState } from 'react'
import {
  DEFAULT_PLATFORM_FLAGS,
  fetchPlatformFlags,
  type PlatformFlags,
} from './platform-flags'

/**
 * Client hook over fetchPlatformFlags. `loaded` lets a page hold its render
 * until the answer is in so a gated surface never flashes on and then off.
 */
export function usePlatformFlags(): PlatformFlags & { loaded: boolean } {
  const [flags, setFlags] = useState<PlatformFlags>(DEFAULT_PLATFORM_FLAGS)
  const [loaded, setLoaded] = useState(false)

  useEffect(() => {
    let cancelled = false
    void fetchPlatformFlags().then((f) => {
      if (cancelled) return
      setFlags(f)
      setLoaded(true)
    })
    return () => {
      cancelled = true
    }
  }, [])

  return { ...flags, loaded }
}
